import React from "react";
import '../components/style.css';

const Footer = () => {
    return(
        <>
            <div className="footerContainer">
                <h4>Copyright@2024 Pokemon inc.</h4>
                <a href="/">Home</a>
                <a href="https://github.com/Furkanc1">Github</a>
                <a href="https://pokeapi.co/">API</a>
                
            </div>
        </>
    )
}

export default Footer;